import { AccessSource } from '@prisma/client';
import { useQuery } from '@tanstack/react-query';

import { CommonFindResult } from '@app/infra-interfaces';
import { AgsRoleRoo } from '@app/integ-ags-interface';
import { LdapRoo } from '@app/integ-ldap-interface';
import { Axios } from '@app/web-components';

const ACCESS_SOURCES_ALL_QUERY_KEY = 'ACCESS_SOURCES_ALL_QUERY_KEY';

const accessSourceKeys = {
  all: [ACCESS_SOURCES_ALL_QUERY_KEY] as const,
  lists: () => [...accessSourceKeys.all, 'list'] as const,
  list: (filters: object) => [...accessSourceKeys.lists(), filters] as const,
};

export const useFindAgsAccesses = (source: AccessSource, name?: string, count?: number, startindex?: number) => {
  const axios = Axios.useAxiosApi();

  const params = {
    name: name?.trim(),
    count,
    startindex,
  };

  let path = '';

  switch (source) {
    case AccessSource.AGS_ROLE:
      path = '/ags/roles';
      break;
    case AccessSource.AGS_ENTITLEMENT:
      path = '/ags/entitlements';
      break;
    default:
      throw new Error(`AccessSource '${source}' is not supported.`);
  }

  return useQuery<CommonFindResult<AgsRoleRoo>>({
    queryKey: accessSourceKeys.list({ source, name, count, startindex }),
    queryFn: async () => {
      const { data } = await axios.get(path, {
        params,
      });
      return data;
    },
  });
};

export const useFindIemGroup = (commonName?: string, exactMatch?: boolean, maxResultCount?: number) => {
  const axios = Axios.useAxiosApi();

  return useQuery<LdapRoo[]>({
    queryKey: accessSourceKeys.list({ source: AccessSource.IEM, name: commonName, exactMatch }),
    queryFn: async () => {
      const { data } = await axios.get(`/ldap/iem-group-find/${commonName}`, {
        params: { exactMatch, maxResultCount },
      });
      return data;
    },
    enabled: !!commonName,
  });
};
